import { ADMIN_SPEND_TRACKER } from "../Contexts/AdminStateContext";

const CHECKING_STATUS_MAP = {
  "checking-unstarted": "Eligible",
  "checking-name": "Eligible",
  "checking-dob": "Eligible",
  "checking-phone": "Eligible",
  "checking-address": "Eligible",
  "checking-identity": "Eligible",
  "checking-employment": "Eligible",
  "checking-agreement": "Eligible",
  "checking-under-review": "VerificationUnderReview",
  "checking-approved": "ApplicationApproved",
  "checking-debit-card": "DebitCardRequested",
  "checking-pending-address": "ApplicationPendingAddressVerification",
  "checking-pending-id": "ApplicationPendingIDVerification",
  "checking-pending-ssn": "ApplicationPendingSSNVerification",
  "checking-denied": "ApplicationDenied",
  "checking-ineligible": "Ineligible",
  "checking-done": "DebitCardActivated",
};

export function getMockStakeDebit(selChecking) {
  const status = CHECKING_STATUS_MAP[selChecking] || "Eligible";
  const isApproved = [
    "ApplicationApproved",
    "DepositAccountCreated",
    "DebitCardRequested",
    "DebitCardActivated",
  ].includes(status);

  return {
    data: {
      data: {
        status,
        available: isApproved ? 34219 : 0,
        account_number: isApproved ? "4821567890" : null,
        routing_number: isApproved ? "084101234" : null,
        avg_monthly_balance: isApproved ? 28750 : 0,
        virtual_card_id: isApproved ? "mock-card-id" : null,
        virtual_card_expiration: isApproved ? "12/28" : null,
        virtual_last_4_digits: isApproved ? "4821" : null,
      },
    },
  };
}

export function getMockPayrollAccounts(selDirectDeposit) {
  const hasAccounts = selDirectDeposit === "dd-done";
  return {
    data: {
      data: {
        accounts: hasAccounts
          ? [{ id: "mock-payroll-1", employer: "Mock Employer", status: "success" }]
          : [],
      },
    },
  };
}

export function getMockCreditReporting(selCreditBuilder) {
  const optedIn = selCreditBuilder === "cb-opted-in";
  return {
    data: {
      data: {
        credit_builder: {
          opted_in: optedIn,
        },
        credit_builder_tracker: optedIn
          ? { months_reported: 6, total_months: 12 }
          : null,
      },
    },
  };
}

export function getMockConnectedAccounts(selConnectedAccounts) {
  const hasAccount = selConnectedAccounts === "connected-one";
  return {
    data: {
      data: {
        accounts: hasAccount
          ? [
              {
                id: "mock-acct-1",
                institution_name: "Chase",
                account_name: "Chase Checking",
                mask: "4821",
                type: "checking",
              },
            ]
          : [],
      },
    },
  };
}

export function getMockRecurringDeposit(selRecurringDeposits) {
  const isActive = selRecurringDeposits === "recurring-yes";
  return {
    data: {
      data: isActive
        ? {
            active: true,
            start_date: new Date().toISOString(),
            frequency_type: "Weekly",
            amount: "200.00",
            originating_account_name: "Chase Checking",
            originating_account_mask: "4821",
          }
        : {
            active: false,
          },
    },
  };
}

export function getMockSpendData(selSpend) {
  const match = ADMIN_SPEND_TRACKER.find((t) => t.state === selSpend);
  if (!match) {
    return { pct: 0, spent: "$0", progressDesc: "$250 more to unlock", ctaGray: "Spend $250 this month to earn", ctaGreen: "$10 Cash Back on Rent" };
  }
  return {
    pct: match.pct,
    spent: match.spent,
    progressDesc: match.progressDesc,
    ctaGray: match.ctaGray,
    ctaGreen: match.ctaGreen,
  };
}

export function getMockRentDetails(selCashback) {
  const isEarning = selCashback === "rent-earning";
  const isNotAvailable = selCashback === "rent-not-available";
  return {
    data: {
      data: {
        my_return_on_rent: {
          rent_match_amount: isEarning ? 18.5 : 0,
          is_my_return_on_rent_visible: !isNotAvailable,
        },
      },
    },
  };
}

export function getMockActivities() {
  return {
    data: {
      data: {
        currentBalance: 342.19,
        lifetimeEarnings: 1284.5,
        transactions: [],
      },
    },
  };
}
